import React from 'react';
import { compose, mapProps, withState, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { getUpdatedTextWithEmoji } from '../../../../common/components/EmojiPicker/emoji-picker-helpers';
import { EmojiPicker } from '../../../../common/components/EmojiPicker/EmojiPicker';
import Input from '../../../../common/components/Input/Input';
import chatbotCRUDActions from "@mm/state/actions/ChatbotCRUDActions";
import { ENTER_CODE } from "@mm/constants/keys-codes";
import './InputBase.scss';
import './sharedStyle.scss';

const MAX_INPUT_LENGTH = 100;
const MAX_BUTTON_LENGTH = 20;
const ERROR_TEXT = `This field value should be at least 1 and less than ${MAX_INPUT_LENGTH} characters`;

const mapStateToProps = state => ({
  chatbotNames: state.chatbot.entities.map(item => item.name),
});

const mapDispatchToProps = dispatch => ({
  createEntity: (entity, crudActions = chatbotCRUDActions) => dispatch(crudActions.create(entity)),
  updateEntity: (entity, crudActions = chatbotCRUDActions) => dispatch(crudActions.update(entity)),
});

function componentWillReceiveProps(newProps) {
  const { valueInStore } = this.props;
  if (
    (newProps.valueInStore && !valueInStore)
    || (newProps.valueInStore !== valueInStore)
  ) {
    newProps.setInputLocalValue(newProps.valueInStore);
  }
}

const onValueChange = ({ setInputLocalValue }) => e => {
  setInputLocalValue(e.target.value);
};

const baseValidateInputValue = ({ chatbotNames: _chatbotNames }) => (inputLocalState) => {
  if (inputLocalState.length > MAX_INPUT_LENGTH) {
    return { error: ERROR_TEXT };
  }
  return null;
};

const onUpdateValue = fieldToUpdateName => props => () => {
  const {
    entity,
    inputLocalState,
    validateInputValue,
    createEntity,
    updateEntity,
    setInputLocalValue,
    valueInStore,
    crudActions,
  } = props;

  const copy = {
    ...entity,
    [fieldToUpdateName]: inputLocalState,
  };

  if (inputLocalState !== entity[fieldToUpdateName]) {
    if (entity.id) {
      if (validateInputValue(inputLocalState)) {
        setInputLocalValue(valueInStore);
        return;
      }
      updateEntity(copy, crudActions);
    } else {
      createEntity(copy, crudActions);
    }
  }
};

const onKeyDownChangeValue = ({ onUpdateValue }) => e => {
  if (e.keyCode === ENTER_CODE) {
    onUpdateValue();
    e.preventDefault();
  }
};


const updateInsertEmoji = props => emoji => {
  const { setInputLocalValue, inputRef, inputLocalState, onUpdateValue } = props;
  const newText = getUpdatedTextWithEmoji(inputLocalState, emoji, inputRef);

  setInputLocalValue(newText);
  onUpdateValue();
};


const InputBase = props => {
  const {
    inputLocalState, onUpdateValue,
    onValueChange, onKeyDownChangeValue,
    inputLabel, inputPlaceholder,
    updateInsertEmoji, setInputRef,
  } = props;
  return (
    <div>
      {
        inputLabel &&
        <span className="bot-publishing-pane__logo-item-subtext">
          {inputLabel}
        </span>
      }

      <div className="input-base__input-wrapper">
        <Input
          placeholder={inputPlaceholder}
          onBlur={onUpdateValue}
          onMouseLeave={onUpdateValue}
          value={inputLocalState}
          onChange={onValueChange}
          onKeyDown={onKeyDownChangeValue}
          className="chatbot__input"
          maxLength={MAX_INPUT_LENGTH}
          inputRef={setInputRef}
        />

        <EmojiPicker
          className="input-base__emoji-picker"
          onEmojiPicked={updateInsertEmoji}
        />
      </div>
    </div>
  )
};

const enhanceWrapped = (fieldToUpdateName, inputLabel, inputPlaceholder,
  crudActions, validateInputValue = baseValidateInputValue) => compose(
  connect(mapStateToProps, mapDispatchToProps),
  mapProps(props => (
    {
      ...props,
      valueInStore: props.entity && props.entity[fieldToUpdateName],
      inputLabel,
      inputPlaceholder,
      validateInputValue,
      crudActions,
    }
  )),
  withState('inputRef', 'setInputRef', null),
  withState('inputLocalState', 'setInputLocalValue', ownPros =>
    (ownPros.valueInStore ? ownPros.valueInStore : '')),
  withHandlers({
    validateInputValue,
    onValueChange,
  }),
  withHandlers({
    onUpdateValue: onUpdateValue(fieldToUpdateName, crudActions),
  }),
  withHandlers({
    onKeyDownChangeValue,
    updateInsertEmoji,
  }),
  lifecycle({ componentWillReceiveProps }),
);


export {
  MAX_INPUT_LENGTH,
  MAX_BUTTON_LENGTH,
  ERROR_TEXT,
  enhanceWrapped,
  InputBase,
};
